<template>
    <span>
        <span v-if="value">
            <v-tooltip bottom>   
            <v-icon @click="showDialog" slot="activator">local_play</v-icon>          
            <span>             
                <RecordPresenter :value="value" />
            </span>
            </v-tooltip>                
        </span>
        <span v-if="(!value) && ruleMatchExecuted">
            <v-tooltip bottom>   
            <v-icon @click="showDialog" slot="activator">add_circle_outlined</v-icon>          
            <span>
               Create rule       
            </span>
            </v-tooltip>                
        </span>
        <gat-dialog-form :value="expanded" @btnClicked="dialogBtnClicked" showDelete=true>
        <gat-form>    
            <v-layout wrap>
                <gat-flex size="xs12"> <gat-field-spacer size="xs12"><category-select v-model="editedRule.RUL_CAT_ID" /></gat-field-spacer></gat-flex>
                <gat-edit size="xs12" label="Text to match" v-model="editedRule.RUL_PARAM" />
                <gat-edit size="xs6" label="Match type" toggle=true v-model="editedRule.RUL_TYPE" />                   
                <gat-edit size="xs6" :disabled="!editedRule.RUL_TYPE" label="Type to match" v-model="editedRule.RUL_PARAM2" />                
            </v-layout>
        </gat-form>     
    </gat-dialog-form>  
</span>
    
</template>

<script>   
    import GatDialogForm from '@/GatComponents/GatDialogForm.vue';
    import GatEdit from '@/GatComponents/GatEdit.vue';
    import GatForm from '@/GatComponents/GatForm.vue';
    import GatUtils from '@/GatComponents/GatUtils';
    import GatFieldSpacer from '@/GatComponents/GatFieldSpacer';
    import CategorySelect from '@/components/CategorySelect.vue';
    import GatFlex from '@/GatComponents/GatFlex.vue';
    
    import {apiDelete,apiPost} from '@/dal.js';
    import RecordPresenter from '../GatComponents/RecordPresenter.vue';
    export default {
        name: 'RuleInfo',
        props: ['value','transaction','ruleMatchExecuted'],
        components: { GatDialogForm, GatEdit, GatForm, CategorySelect, GatFlex, GatFieldSpacer, RecordPresenter },
        data: function() {
            return	{
                expanded:false,
                editedRule : {},
            }
        },


        created(){
        },

        watch:{
        },

        methods:{
            dialogBtnClicked(btn){
                if(btn=="cancel"){
                    this.expanded = false;
                } 

                if(btn=="delete"){
                    apiDelete('rule/'+this.editedRule.RUL_ID).then(()=>{
                        this.$store.commit("removeRule",this.editedRule);                     
                        this.$emit("input",undefined);
                    });
                    this.expanded = false;
        
                } 

                if(btn=="save"){
                    let rule = GatUtils.makeCopyViaJson(this.editedRule);
                    apiPost('rule',rule).then(data=>{
                       rule.RUL_ID = data.id;
                       this.$store.commit("updateRule",rule);      
                    });
                    this.expanded = false;
                  
                } 
            },

            ruleType(type){
                let result="Text match";
                if(type==1){
                    result="Text and category"
                }
                return result;
            },

            showDialog(){
                this.editedRule = GatUtils.makeCopyViaJson(this.value);
                if(!this.value){
                    this.editedRule = {
                        RUL_PARAM : this.transaction.TRA_TEXT,
                        RUL_PARAM2 : this.transaction.TRA_TYPE,
                        RUL_CAT_ID : this.transaction.TRA_CAT_ID,
                    };
                }
                this.expanded = true;
            },
        },
    }
</script>

<style scoped>

</style>
